// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionNewListings_root__3v2tG","title":"SectionNewListings_title__YPhzh","listings":"SectionNewListings_listings__3E6C6","listing":"SectionNewListings_listing__TY7n_"};